import { AlertCircle, Check, Clock, Loader2 } from "lucide-react";

interface IProps {
  isAutoSaving: boolean;
  hasUnsavedChanges: boolean;
  hasError: boolean;
  lastSavedAt: Date | null;
}

function formatTime(date: Date) {
  return date.toLocaleTimeString("pt-BR", {
    hour: "2-digit",
    minute: "2-digit",
  });
}

function AutoSaveIndicator({
  isAutoSaving,
  hasUnsavedChanges,
  hasError,
  lastSavedAt,
}: IProps) {
  if (isAutoSaving) {
    return (
      <span className="flex items-center gap-1.5 text-xs font-medium text-slate-500">
        <Loader2 className="h-3.5 w-3.5 animate-spin" />
        Salvando rascunho...
      </span>
    );
  }

  if (hasError) {
    return (
      <span className="flex items-center gap-1.5 text-xs font-medium text-red-600">
        <AlertCircle className="h-3.5 w-3.5" />
        Falha ao salvar rascunho
      </span>
    );
  }

  if (hasUnsavedChanges) {
    return (
      <span className="flex items-center gap-1.5 text-xs font-medium text-slate-600">
        <Clock className="h-3.5 w-3.5" />
        Alterações não salvas
      </span>
    );
  }

  if (lastSavedAt) {
    return (
      <span className="flex items-center gap-1.5 text-xs font-medium text-emerald-600">
        <Check className="h-3.5 w-3.5" />
        Rascunho salvo às {formatTime(lastSavedAt)}
      </span>
    );
  }

  return null;
}

export default AutoSaveIndicator;
